import DetailTitle from "@/components/DetailTitle";
import classNames from 'classnames';
import styles from "./index.module.scss";
import intl from "react-intl-universal";
import { useState } from "react";
import { Button, Form, Input, message, Modal } from "antd";
import { getEmailCode, checkEmailCode } from "@/apis/user"
import { subscribeEmail } from "@/apis/community"
import './index.scss'

let timer = null
const { Search } = Input;

const MailingLists = () => {
	const email = localStorage.getItem("email") || ""

	const [isOpen, setIsOpen] = useState(false)
	const [captchaUuid, setCaptchaUuid] = useState("")
	const [form] = Form.useForm();
	const [count, setCount] = useState(0)

	const subscribe = () => {
		form.setFieldsValue({
			emailCode: "",
			email: email
		})
		setIsOpen(true)
	}

	// 获取邮箱验证码
	const getCode = () => {
		const email = form.getFieldValue("email")
		form.setFieldValue(
			"emailCode", ""
		)
		timer && clearInterval(timer)
		getEmailCode({
			email: email,
			type: 3
		}).then(res => {
			setCaptchaUuid(res.data)
			message.open({
				type: "success",
				content: intl.get("Register.emailDes"),
				duration: 10,
			})
		}).catch(err => { })

		// 倒计时
		let num = 120
		timer = setInterval(() => {
			setCount(num - 1)
			if (num === 0) {
				clearInterval(timer)
			}
			num = num - 1
		}, 1000)
	}

	// 订阅
	const onFinish = (values) => {
		// 获取邮箱验证码
		checkEmailCode({
			captchaName: values.email,
			captchaUuid: captchaUuid,
			captchaValue: values.emailCode
		}).then(res => {
			subscribeEmail({
				email: values.email,
				captchaRecord: res.data,
			}).then(res => {
				timer && clearInterval(timer)
				message.success(intl.get("community.Subscribe successfully"))
				setIsOpen(false)
			}).catch(err => {
				message.error(intl.get("community.Subscribe failed"))
			})
		}).catch(err => {
		})

	}
	return <div className={classNames('container',styles.mailingListsBox)}>
		<DetailTitle title="Mailing Lists" />
		<div>{intl.get("About.Email")}<a href="mailto:info@ogeoa.net">info@ogeoa.net</a></div>
		<div className={styles.contentBox}>
			{intl.get('community.mailDes1')}
			<a href="#" onClick={subscribe}> {intl.get('community.subscribe')}</a>
			{intl.get('community.mailDes2')}
		</div>

		<Modal
			title={intl.get('community.subscribe')}
			width={500}
			open={isOpen}
			maskClosable={false}
			footer={null}
			onCancel={() => {
				setIsOpen(false)
			}}>
			<Form
				onFinish={onFinish}
				layout="vertical"
				autoComplete="off"
				form={form}
				className={styles.modalFormBox}
			>
				<Form.Item
					label={intl.get("Email")}
					name="email"
					rules={[
						{
							required: true,
							message: intl.get("community.Please enter your email address"),
						}, {
							type: 'email',
							message: intl.get("Email must be formatted correctly")
						}
					]}
				>
					<Search
						enterButton={count > 0 ? intl.get("User.Get code") + count : intl.get("User.Get code")}
						disabled={count > 0}
						onSearch={getCode}
					/>
				</Form.Item>

				<Form.Item
					label={intl.get("Register.Email verification code")}
					name="emailCode"
					rules={[
						{
							required: true,
							message: intl.get("Register.Please enter the six digit code received by email"),
						},
					]}
				>
					<Input.OTP />
				</Form.Item>
				<Form.Item style={{ "marginTop": "40px" }}>
					<Button type="primary" htmlType="submit">
						{intl.get("Share.Submit")}
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	</div>
}
export default MailingLists;